const components = {
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundColor: '#f9fcf9',
      },
    },
  },
};
export default components;
